// ════════════════════════════════════════════════════════════════════
// Admin layout primitives — shared page chrome for the admin tabs so they
// feel like one product surface. Extracted verbatim from App.js (pure,
// self-contained — hardcoded palette, no theme/hook deps).
// ════════════════════════════════════════════════════════════════════
export function AdminPage({ children }) {
  return (
    <div style={{ padding:"28px 28px 40px", maxWidth:1180, margin:"0 auto" }}>
      {children}
    </div>
  );
}

export function AdminPageHeader({ icon, title, description, right }) {
  return (
    <div style={{ marginBottom:24, display:"flex", alignItems:"flex-start", justifyContent:"space-between", gap:20, flexWrap:"wrap" }}>
      <div>
        <div style={{ display:"flex", alignItems:"center", gap:11, marginBottom:6 }}>
          <div style={{
            width:32, height:32, borderRadius:8,
            background:"linear-gradient(135deg, #1e1b4b 0%, #0f172a 100%)",
            display:"flex", alignItems:"center", justifyContent:"center",
            boxShadow:"0 2px 6px rgba(15,23,42,.20)",
          }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              {Array.isArray(icon) ? icon.map((d, i) => <path key={i} d={d}/>) : <path d={icon}/>}
            </svg>
          </div>
          <h1 style={{ fontSize:22, fontWeight:700, color:"#0f172a", letterSpacing:"-.5px", margin:0, lineHeight:1.2 }}>
            {title}
          </h1>
        </div>
        {description && (
          <p style={{ fontSize:13, color:"#64748b", margin:0, fontWeight:400, lineHeight:1.5, maxWidth:680, paddingLeft:43 }}>
            {description}
          </p>
        )}
      </div>
      {right && <div style={{ flexShrink:0 }}>{right}</div>}
    </div>
  );
}

export function AdminSectionLabel({ children }) {
  return (
    <div style={{ display:"flex", alignItems:"center", gap:10, margin:"4px 0 12px" }}>
      <h2 style={{
        fontSize:12.5, fontWeight:700, color:"#475569", margin:0,
        textTransform:"uppercase", letterSpacing:0.6,
      }}>{children}</h2>
      <div style={{ flex:1, height:1, background:"#e2e8f0" }}/>
    </div>
  );
}

export function AdminCard({ children, accent, style }) {
  return (
    <div style={{
      background:"#fff", border:"1px solid #e2e8f0", borderRadius:10,
      overflow:"hidden", boxShadow:"0 1px 2px rgba(15,23,42,.04)",
      ...(accent ? { borderLeft:`3px solid ${accent}` } : {}),
      ...(style || {}),
    }}>
      {children}
    </div>
  );
}
